import { gql } from '@apollo/client';

export default gql`
  query warrantyNotes(
    $warrantyId: ID!
  ) {
    warrantyNotes(
      warrantyId: $warrantyId
    ) {
      id
      message
      warrantyId
      adminUserId
      partnerUserId
      showPartner
      showUser
      adminUser {
        id
        firstName
        lastName
      }
      partnerUser {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;
